import { AppSettings } from '@/constants/app.settings';
import Rollbar from 'rollbar';

export const rollbar = new Rollbar({
  accessToken: import.meta.env.VITE_APP_rollbarClientAccessToken,
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled: AppSettings.isProduction,
  payload: {
    // Todo: Revert environment back to production once the vue2 is deprecated so that there is no namespace collition
    environment: AppSettings.env,
    client: {
      javascript: {
        source_map_enabled: true,
        guess_uncaught_frames: true,
        code_version: import.meta.env.VITE_APP_lastestCommitId,
      },
    },
  },
});
